import { useEffect } from "react";
import { Question } from "src/pods/pairshare/types";
import logEvent from "src/utils/logEvent";
import styles from "./PairShareResult.module.css";

type Props = {
  question: Question;
};

export default function PairShareResult({ question }: Props) {
  useEffect(() => {
    logEvent({ eventName: "pairshare.result.open" });
    return () => {
      logEvent({ eventName: "pairshare.result.close" });
    };
  }, []);

  const text = question.text ?? "";

  return (
    <article className={styles.page}>
      <section className={styles.card}>
        <div className={styles.question}>
          {text.split("\n").map((line, index) => (
            <div key={index} className={styles.line}>
              {line}
            </div>
          ))}
        </div>
      </section>
    </article>
  );
}
